import React from "react";
import Grid from "@mui/material/Grid";
import { TextField } from "@mui/material";
import { FormControl } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { systemStatusOptions } from "utils/options/systemStatusOptions";

export default function ClientBankFileFormSystem({
  formData,
  handleInputChange,
}) {
  return (
    <>
      <Grid container spacing={3} sx={{ marginTop: "10px" }}>
        {/* CreateTime */}

        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled={true}
            name="ParseStatus"
            onChange={(e) => handleInputChange("ParseStatus", e.target.value)}
            label="Kontrollstatus"
            value={formData.ParseStatus}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="text"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            disabled={true}
            name="ParseMessage"
            onChange={(e) => handleInputChange("ParseMessage", e.target.value)}
            label="Kontrollmeddelande"
            value={formData.ParseMessage}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="text"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <FormControl margin="dense" fullWidth sx={{ textAlign: "left" }}>
            <InputLabel>Status</InputLabel>
            <Select
              name="SystemStatus"
              value={formData.SystemStatus}
              onChange={(e) =>
                handleInputChange("SystemStatus", e.target.value)
              }
              label="SystemStatus"
              size="small"
            >
              {systemStatusOptions.map((options) => (
                <MenuItem key={options.Value} value={options.Value}>
                  {options.Name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Skapad"
            label="Skapad"
            value={formData.CreateTime}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            disabled
          />
        </Grid>
      </Grid>
    </>
  );
}
